/**
 * <s-recent-searches> — Shows the shopper's recent search terms (saved on this device)
 * inside the header search pop-up while the search box is empty.
 * Records a term when the search form is submitted, when a result in the pop-up is
 * opened, and when a search results page loads (data-current-terms).
 */
const KEY = 'distvnt:recent-searches';
const MAX = 8;

const read = () => {
  try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
};
const write = (list) => {
  try { localStorage.setItem(KEY, JSON.stringify(list)); } catch {}
};
export const recordSearch = (term) => {
  const clean = String(term || '').trim().replace(/\s+/g, ' ');
  if (clean.length < 2) return;
  const list = read().filter((t) => t.toLowerCase() !== clean.toLowerCase());
  list.unshift(clean.slice(0, 60));
  write(list.slice(0, MAX));
};

class SRecentSearches extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    const { signal } = this.#ac;
    const current = this.dataset.currentTerms;
    if (current) recordSearch(current);

    this.list = this.querySelector('[data-recent-list]');
    this.template = this.querySelector('template[data-recent-item]');
    this.input = document.getElementById('predictive-search-input');
    const dialog = this.closest('dialog');

    this.querySelector('[data-recent-clear]')?.addEventListener('click', () => {
      write([]);
      this.render();
      this.input?.focus();
    }, { signal });

    this.input?.form?.addEventListener('submit', () => recordSearch(this.input.value), { signal });
    this.input?.addEventListener('input', () => this.render(), { signal });

    // Opening a result or "View all results" from the pop-up counts as a search.
    dialog?.addEventListener('click', (e) => {
      const link = e.target.closest('a[href]');
      if (link && !this.contains(link) && this.input?.value) recordSearch(this.input.value);
    }, { signal, capture: true });

    dialog?.addEventListener('toggle', () => this.render(), { signal });
    this.render();
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  render() {
    const terms = read();
    const typing = this.input && this.input.value.trim() !== '';
    this.hidden = typing || terms.length === 0;
    if (!this.list || !this.template) return;
    this.list.replaceChildren(...terms.map((term) => {
      const item = this.template.content.firstElementChild.cloneNode(true);
      const link = item.querySelector('a');
      link.href = `${this.dataset.searchUrl}?q=${encodeURIComponent(term)}`;
      link.querySelector('[data-recent-term]').textContent = term;
      link.addEventListener('click', () => recordSearch(term));
      return item;
    }));
  }
}

if (!customElements.get('s-recent-searches')) customElements.define('s-recent-searches', SRecentSearches);
